import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/list${`?query=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/list`;

export const URL = (searchText: string): RouteDefinition => `${baseRoute}/list?query=${searchText}`;
